var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNavigationHorizontalRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.75281 17.9997H21.2528C21.667 17.9997 22.0028 18.3355 22.0028 18.7497C22.0028 19.1294 21.7207 19.4432 21.3546 19.4928L21.2528 19.4997H2.75281C2.3386 19.4997 2.00281 19.1639 2.00281 18.7497C2.00281 18.37 2.28497 18.0562 2.65104 18.0065L2.75281 17.9997H21.2528H2.75281ZM2.75281 11.5027H21.2528C21.667 11.5027 22.0028 11.8385 22.0028 12.2527C22.0028 12.6324 21.7207 12.9462 21.3546 12.9959L21.2528 13.0027H2.75281C2.3386 13.0027 2.00281 12.6669 2.00281 12.2527C2.00281 11.873 2.28497 11.5592 2.65104 11.5095L2.75281 11.5027H21.2528H2.75281ZM2.75195 5.00293H21.252C21.6662 5.00293 22.002 5.33872 22.002 5.75293C22.002 6.13263 21.7198 6.44642 21.3537 6.49608L21.252 6.50293H2.75195C2.33774 6.50293 2.00195 6.16714 2.00195 5.75293C2.00195 5.37323 2.28411 5.05944 2.65018 5.00978L2.75195 5.00293H21.252H2.75195Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavigationHorizontalRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/navigation-horizontal-regular.07387070.svg";
export { ForwardRef as ReactComponent };